import { render } from "./UserAssignedTools.vue?vue&type=template&id=15bdf0fe&scoped=true&ts=true&lang=pug"
import script from "./UserAssignedTools.vue?vue&type=script&lang=ts"
export * from "./UserAssignedTools.vue?vue&type=script&lang=ts"

import "./UserAssignedTools.vue?vue&type=style&index=0&id=15bdf0fe&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15bdf0fe"]])

export default __exports__